import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { RefinementList, connectStateResults } from 'react-instantsearch-dom';
import { useDropdown } from '/hooks';

const transform = (items) => items.sort((a, b) => {
    if (a.label < b.label) {
        return -1;
    }

    if (a.label > b.label) {
        return 1;
    }

    return 0;
});

const InternalDropdownFilter = ({ label, singular, plural, searchState, attribute }) => {
    const component = useRef(null);
    const {
        status,
        toggle,
    } = useDropdown(component, 'closed');

    const selectedItemsCount = (searchState.refinementList && searchState.refinementList[attribute] || []).length;

    return (
        <div className={`dropdown-filter is-${status}`} ref={component}>
            <button
                className={`dropdown-filter__trigger ${selectedItemsCount > 0 && 'has-values'}`}
                onClick={toggle}
            >
                {selectedItemsCount === 0 && label}
                {selectedItemsCount === 1 && (
                    <React.Fragment>
                        <strong>1</strong> {singular}
                    </React.Fragment>
                )}
                {selectedItemsCount > 1 && (
                    <React.Fragment>
                        <strong>{selectedItemsCount}</strong> {plural}
                    </React.Fragment>
                )}
            </button>
            <svg className="dropdown-filter__icon" viewBox="0 0 48 48">
                <use xlinkHref="#icon-dropdown" />
            </svg>
            <div className="dropdown-filter__content">
                <RefinementList
                    attribute={attribute}
                    transformItems={transform}
                    limit={999}
                />
            </div>
        </div>
    );
};

const DropdownFilter = connectStateResults(InternalDropdownFilter);

DropdownFilter.propTypes = {
    label: PropTypes.string.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
    attribute: PropTypes.string.isRequired,
};

export { DropdownFilter };
